document.addEventListener("DOMContentLoaded", () => {  
  if (!document.body.classList.contains("template-product")) return;

  const productSection = document.querySelector(".product-section");
  const collapsibleSection = productSection?.nextElementSibling;

  if (!collapsibleSection || !collapsibleSection.classList.contains("collapsible-content-section")) return;

  const infoContainer = productSection.querySelector(".main-product .product__info-container");
  if (!infoContainer) return;

  const productPopup = infoContainer.querySelector(".product-popup");

  if (productPopup) {
    infoContainer.insertBefore(collapsibleSection, productPopup);
  } else {
    infoContainer.appendChild(collapsibleSection);
  }
});